export function isBitmaskMatching(value: number, bitsToCheckIfPresent: number): boolean {
    return bitsToCheckIfPresent === (value & bitsToCheckIfPresent)
}

export function addBits(value: number, bitsToAdd: number): number {
    return value | bitsToAdd
}

export function removeBits(value: number, bitsToRemove: number): number {
    return value & ~bitsToRemove
}

export const createBitmask = (...bits: number[]): number =>
    bits.reduce((acc: number, bit: number): number => addBits(acc, bit), 0)
